import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

import { LoginModule } from './login/login.module';
import { AuthService } from './auth/auth.service';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './shared/http/auth.interceptor';
import { HomeComponent } from './shared/components/home/home.component';

// KPE-865 BY ML 27JUN25 oktaAuth provider code moved from main-app module to root app module
console.log(
  "clientId:", environment.OKTAAUTH_CLIENT_ID,
  "issuer:", environment.OKTAAUTH_ISSUER,
  "redirectUri:", environment.OKTAAUTH_REDIRECT_URL
);

const oktaAuth = new OktaAuth({
  issuer: environment.OKTAAUTH_ISSUER,
  clientId: environment.OKTAAUTH_CLIENT_ID,
  redirectUri: environment.OKTAAUTH_REDIRECT_URL
});
@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LoginModule,
    OktaAuthModule
  ],
  providers: [
    AuthService,
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
